import axios from 'axios'
import Config from '../../config'
import Vue from "vue";

const API_URL = `${Config.apiServers.url}`

export class AuthService {
  // eslint-disable-next-line class-methods-use-this
  login(user) {
    return axios
      .post(`${API_URL}/auth/login`, {
        mobile: user.mobile,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
        },
      })
    // eslint-disable-next-line consistent-return
      .then(response => {
        if (response.data.status === 'success') {
         // localStorage.setItem('verifyLogin', JSON.stringify(response.data.result))
        }
        return response.data
      })
  }

  // eslint-disable-next-line class-methods-use-this
  loginVerify(verifyLogin, payload) {
    return axios
      .post(`${API_URL}/auth/login/mobile-verify`, {
        mobile: payload.mobile,
        code: payload.code,
      })
      .then(response => {
        if (response.data.status === 'success') {
          Vue.prototype.$isAdmin = response.data.result.isAdmin
          localStorage.setItem('user', JSON.stringify(response.data.result))
        }
        return response.data
      })
  }

  // eslint-disable-next-line class-methods-use-this
  logout() {
    localStorage.removeItem('user')
  }

  // eslint-disable-next-line class-methods-use-this
  register(user) {
    return axios
      .post(`${API_URL}/auth/register`, {
        name: user.name,
        family: user.family,
        mobile: user.mobile,
      }, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
        },
      })
      // eslint-disable-next-line consistent-return
      .then(response => {
        if (response.data.status === 'success') {
          // localStorage.setItem('verifyRegister', JSON.stringify(response.data.result))
        }
        return response.data
      })
  }

  // eslint-disable-next-line class-methods-use-this
  registerVerify(payload) {
    return axios
      .post(`${API_URL}/auth/register/mobile-verify`, {
        mobile: payload.mobile,
        code: payload.code,
      })
      .then(response => {
        console.log(response.data.status)
        if (response.data.status === 'success') {
          console.log(JSON.stringify(response.data.result))
          localStorage.setItem('user', JSON.stringify(response.data.result))
        }
        return response.data
      })
  }
}

export default new AuthService()
